import { render, staticRenderFns } from "./AdminAccess.vue?vue&type=template&id=7ddf7dde&scoped=true"
import script from "./AdminAccess.vue?vue&type=script&lang=js"
export * from "./AdminAccess.vue?vue&type=script&lang=js"
import style0 from "./AdminAccess.vue?vue&type=style&index=0&id=7ddf7dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf7dde",
  null
  
)

export default component.exports